import axios from "axios";

const learning_path = {


    async create(data){
        return (await axios.post('/api/learning-path', data)).data;
    },

    async destroy(path_id){
        return (await axios.delete(`/api/learning-path/${path_id}`)).data;
    },

    async bulk(filters = {}){
        return (await axios.get('/api/learning-path', {
            params: filters,
        })).data;
    },

    async get(id){
        const paths = (await axios.get('/api/learning-path', {
            params: {id},
        })).data;
        return paths.length ? paths[0] : null;
    },

    async updateSettings(path_id, data){
      return (await axios.put(`/api/learning-path/${path_id}/settings`, data)).data;
    },


};


export default learning_path;
